<template>
	<nk-page commercialAccess="Salary" class="" policyClaims="Salary_SalaryPeriod_Management" :buttons="Object.values(bottomButtons)" tabindex="101" startup>
		<template #badges>
			<nk-badge system="salary">
				<nk-badge-item type="system" modelValue="salary"></nk-badge-item>
				<nk-badge-item type="system" modelValue="salary" :title="$t('forms.SalaryPeriods')"></nk-badge-item>
			</nk-badge>
		</template>
		<month-selector ref="monthSelector" :options="options" v-model="selectedPeriod"></month-selector>
	</nk-page>
</template>

<script lang="ts">
	import $sc from '@/plugins/shortcut.collection'
	import monthSelector from '@/views/salary/salary-period/period-selector.vue'
	import createPeriod from '@/views/salary/salary-period/salary-period-modify.vue'
	import { defineComponent } from 'vue'
	import { isEmpty } from '@/statics/validators'
	import { mapActions, mapGetters } from 'vuex'
	import { TYPE } from 'vue-toastification'
	import copyPeriod from '@/views/salary/salary-period/copy-period.vue'

	export default defineComponent({
		name: "preview-months",
		modal: {
			size: 'lg',
			stateUID: 'preview-months',
			helpTag: 'PreviewPeriods'
		},
		props: {
			options: Object
		},
		components: {
			'month-selector': monthSelector
		},
		computed: {
			...mapGetters({
				getSalaryPeriod: 'appContext/getSalaryPeriod',
			}),
		},
		mounted() {
			this.selectedPeriod = this.getSalaryPeriod
			this.grandPType = this.grandParentType()
			if (this.grandPType === 'modal') {
				this.insertMonthBtn.visible = false
				this.copyButton.visible = false
				this.selectButton.visible = true
			} else {
				this.insertMonthBtn.visible = true
				this.copyButton.visible = true
				this.selectButton.visible = false
			}
			this.prepareWindow(this.$t(`salary.period.${this.grandPType === 'modal' ? 'select-period' : 'preview-periods'}`), [
				this.insertMonthBtn,
				this.selectButton,
				this.copyButton
			])
		},
		data() {
			return {
				grandPType: null as any,
				selectedPeriod: null as any,
				insertMonthBtn: {
					title: this.$t('salary.insert-month'),
					shortcut: $sc.find('insert'),
					icon: 'fa-regular fa-calendar-days',
					visible: true,
					isPrimary: false,
					policyClaims: 'Salary_SalaryPeriod_Add',
					handle: () => {
						this.showModal({ component: createPeriod, options: { getMonths: this.$refs.monthSelector.getPeriods } })
							.catch(() => { })
							.finally(() => {
								// this.$refs.monthSelector.getPeriods()
							})
					},
					selfButton: true,
				},
				copyButton: {
					title: this.$t('PrivilegeTypes.Copy'),
					shortcut: $sc.find('copy'),
					icon: 'copy',
					visible: true,
					isPrimary: false,
					policyClaims: 'Salary_SalaryPeriod_Copy',
					handle: this.handlerBtnCopy,
					selfButton: true,
				},
				selectButton: {
					title: this.$t('select'),
					shortcut: $sc.find('enter-only'),
					icon: 'check',
					isPrimary: true,
					visible: false,
					handle: this.insertBtnHandler,
					policyClaims: 'Salary_SalaryPeriod_Management',
				},
				bottomButtons: {
					refreshBtn: {
						title: this.$t('trs.chq.oper.refresh'),
						icon: 'sync',
						handle: async () => {
							await this.refreshSalaryPeriod()
							this.$refs.monthSelector.getPeriods()
						},
					},
				},
				existingMonths: [],
			}
		},
		methods: {
			...mapActions({
				refreshSalaryPeriod: 'salaryPeriods/refresh'
			}),
			insertBtnHandler() {
				if (isEmpty(this.selectedPeriod))
					return this.$toast(this.$t('salary.period.period-not-selected'))
				else if (this.selectedPeriod?.id === this.getSalaryPeriod?.id)
					return this.$toast(this.$t('salary.period.selected-same-as-current-salary-period'), { type: TYPE.ERROR })
				this.resolve(this.selectedPeriod)
			},
			handlerBtnCopy() {
				this.showModal({
					component: copyPeriod,
					options: {
					}
				}).catch(() => { })
			},
		}
	})
</script>

<style scoped></style>